import Alpine from 'alpinejs';

Alpine.data('rule', (thickness, spaceBefore, spaceAfter, color = '') => ({
  thickness,
  spaceBefore,
  spaceAfter,
  color,

  get styles() {
    return {
      height: this.thickness + 'px',
      marginTop: this.spaceBefore + 'px',
      marginBottom: this.spaceAfter + 'px',
      ...(this.color ? { backgroundColor: this.color } : {})
    };
  }
}));